module.exports = __webpack_public_path__ + "static/media/v5concox.662a1899.jpeg";